<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Escolas"
            description=""
            url="/administracao"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-2771"
            pageIdentifier="escolas"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="d-flex justify-content-end mb-3">
            <b-button variant="primary" @click="abrirModalAdicionar">
              Adicionar escola <i class="icofont-plus"></i>
            </b-button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <tabela-cadastros
            :cadastros="cadastros"
            :loading="loading"
            @editar="editarEscola"
          ></tabela-cadastros>
        </div>
      </div>
    </div>

    <!-- Modal Adicionar -->
    <b-modal
      id="modal-adicionar-escola"
      ref="modalAdicionarEscola"
      :title="modalMode === 'edit' ? 'Editar escola' : 'Adicionar escola'"
      centered
      hide-footer
      @hidden="resetForm"
    >
      <ValidationObserver ref="form">
        <b-alert
          v-if="modalAlert.show"
          :variant="modalAlert.variant"
          show
          class="mb-3"
        >
          {{ modalAlert.message }}
        </b-alert>

        <div v-if="modalLoading" class="modal-loading">
          <div class="text-center">
            <b-spinner label="Carregando" />
          </div>
        </div>
        <b-form v-else @submit.prevent="salvarEscola">
          <validation-provider v-slot="{ errors }" rules="required">
            <div class="form-group">
              <label for="inep">INEP</label>
              <input
                id="inep"
                type="text"
                class="form-control"
                v-model.trim="form.inep"
                placeholder=""
                :disabled="modalMode === 'edit'"
              />
              <div class="error">{{ errors[0] }}</div>
            </div>
          </validation-provider>

          <validation-provider v-slot="{ errors }" rules="required">
            <div class="form-group">
              <label for="nome">Nome da escola</label>
              <input
                id="nome"
                type="text"
                class="form-control"
                v-model.trim="form.nome"
                placeholder=""
              />
              <div class="error">{{ errors[0] }}</div>
            </div>
          </validation-provider>

          <validation-provider v-slot="{ errors }" rules="required">
            <div class="form-group">
              <label>Equipe responsável</label>
              <vue-select
                class="select-equipes"
                :options="equipesOptions"
                label="no_esf_eap"
                placeholder=""
                v-model="form.equipe_responsavel"
              >
                <template slot="option" slot-scope="option">
                  {{ option.no_esf_eap }} -
                  {{ option[`ine_esf_eap`] }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>

              <div class="error">{{ errors[0] }}</div>
            </div>
          </validation-provider>

          <validation-provider v-slot="{ errors }" rules="required">
            <div class="form-group">
              <label>Faz parte do PSE atual?</label>

              <div class="d-flex align-items-center">
                <label class="mr-4 mb-0">
                  <input
                    type="radio"
                    name="pse-radio"
                    :value="1"
                    v-model.number="form.pse"
                  />
                  <span class="ml-1">Sim</span>
                </label>

                <label class="mb-0">
                  <input
                    type="radio"
                    name="pse-radio"
                    :value="0"
                    v-model.number="form.pse"
                  />
                  <span class="ml-1">Não</span>
                </label>
              </div>

              <div class="error">{{ errors[0] }}</div>
            </div>
          </validation-provider>

          <div class="d-flex justify-content-end">
            <b-button
              variant="secondary"
              class="mr-2"
              @click="fecharModalAdicionar"
            >
              Cancelar
            </b-button>

            <b-button variant="primary" type="submit" :disabled="saving">
              Salvar
              <b-spinner v-if="saving" small class="ml-2" />
            </b-button>
          </div>
        </b-form>
      </ValidationObserver>
    </b-modal>

    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import TabelaCadastros from './TabelaCadastros.vue'
import SectionTitle from '@/components/SectionTitle'
import SelectsV2 from '@/components/utils/SelectsV2.vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()

export default {
  metaInfo: {
    title: 'Escolas',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    TabelaCadastros,
    SectionTitle,
    ValidationObserver,
    ValidationProvider,
    SelectsV2,
  },
  data() {
    return {
      cadastros: [],
      loading: false,
      saving: false,
      form: {
        inep: '',
        nome: '',
        equipe_responsavel: '',
        pse: null, // 1 ou 0
      },
      pseOptions: [
        { text: 'Sim', value: 1 },
        { text: 'Não', value: 0 },
      ],
      modalAlert: {
        show: false,
        variant: 'success', // success | danger | warning | info
        message: '',
      },
      modalMode: 'create', // 'create' | 'edit'
      modalLoading: false,
      escolaSelecionada: null,
      inepOriginal: null,
    }
  },
  computed: {
    equipesOptions() {
      return this.$store.state.equipesV2 ?? []
    },
  },
  mounted() {
    this.buscarEscolas()
  },
  methods: {
    /**
     * Busca as escolas do município.
     */
    async buscarEscolas() {
      try {
        this.loading = true
        const response = await this.$api.get(
          '/app/municipio/' + this.$store.state.cod_ibge + '/escolas'
        )
        if (response) {
          this.cadastros = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    /**
     * Manipula a alteração da equipe selecionada.
     *
     * @param {Object} item Equipe selecionada no componente
     */
    onChangeEquipe(item) {
      this.form.equipe_responsavel = item
    },

    /**
     * Abrir modal adicionar escola
     */
    abrirModalAdicionar() {
      this.resetForm()
      this.modalMode = 'create'
      this.$refs.modalAdicionarEscola.show()
    },

    /**
     * Fechar modal adicionar escola
     */
    fecharModalAdicionar() {
      this.$refs.modalAdicionarEscola.hide()
    },

    /**
     * Resetar formulário
     */
    resetForm() {
      this.inepOriginal = null
      this.form = {
        inep: '',
        nome: '',
        equipe_responsavel: '',
        pse: null,
      }
      this.saving = false
      this.modalAlert = {
        show: false,
        variant: 'success',
        message: '',
      }
    },

    /**
     * Editar escola
     * @param {object} item
     */
    async editarEscola(item) {
      try {
        this.resetForm()
        this.modalMode = 'edit'
        this.modalLoading = true
        this.escolaSelecionada = item

        const response = await this.$api.get(
          `/app/municipio/${this.$store.state.cod_ibge}/escolas/${item.nu_identificador}`
        )

        const escola = response?.data.data

        this.inepOriginal = escola.nu_identificador
        this.form.inep = escola.nu_identificador
        this.form.nome = escola.no_estabelecimento
        this.form.pse = escola.st_pse_atual
        const equipe = this.$store.state.equipesV2.find((el) => {
          return el.ine_esf_eap == escola.nu_ine_resp
        })
        if (equipe != undefined) {
          this.form.equipe_responsavel = equipe
        } else {
          this.form.equipe_responsavel = null
        }

        this.$refs.modalAdicionarEscola.show()
      } catch (error) {
        console.log(error)
        this.modalAlert = {
          show: true,
          variant: 'danger',
          message: 'Erro ao carregar escola para edição.',
        }
      } finally {
        this.modalLoading = false
      }
    },

    /**
     * Salvar escola
     */
    async salvarEscola() {
      const isValid = await this.$refs.form.validate()
      if (!isValid) {
        return
      }

      try {
        this.saving = true
        this.modalAlert.show = false

        const payload = {
          nu_identificador:
            this.modalMode === 'edit' ? this.inepOriginal : this.form.inep,
          no_estabelecimento: this.form.nome,
          nu_ine_resp: this.form.equipe_responsavel.ine_esf_eap,
          st_pse_atual: this.form.pse,
        }

        const response = await this.$api.post(
          '/app/municipio/' + this.$store.state.cod_ibge + '/escolas',
          payload
        )

        const data = response?.data || {}

        if (data.error === false) {
          this.modalAlert = {
            show: true,
            variant: 'success',
            message: data.message || 'Escola cadastrada com sucesso!',
          }

          await this.buscarEscolas()

          return
        }

        this.modalAlert = {
          show: true,
          variant: 'danger',
          message: data.message || 'Erro ao cadastrar escola.',
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.saving = false
      }
    },
  },
}
</script>

<style>
#modal-adicionar-escola .select-equipes {
  margin-bottom: 0;
}
#modal-adicionar-escola .select-equipes .v-select {
  flex: 1 1 100%;
}
</style>
